import React from "react";
import Show from "../../../utils/show.component";
import { usd } from "../../../utils/utils";

export const AuthPaymentContainer = (props) => {
  const hide = props.hide === true ? true : false;

  const conditionalTitleClasses =
    props.title === "Payment Summary" || "AutoPay Cancelled" ? "mx-4 mt-4" : "my-5";

  return (
    <div className="px-2 m-auto" data-e2e-id={"paymentContainer-" + props.title}>
      <h2 className={"text-centered bold " + conditionalTitleClasses}>{props.title}</h2>
      <div className="mx-auto mb-4 text-centered" style={{ maxWidth: "570px" }}>
        {props.subtitle}
      </div>
      <Show condition={props.hide !== true}>
        <div className="mb-5 container-fluid auth-payment-container">
          {props.topChildren}
          <div className="py-4 px-5">
            <div className="m-auto auth-display-interior">{props.children}</div>
          </div>
        </div>
      </Show>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/auth-payment-container.component.js